import { render, staticRenderFns } from "./EditTagScoreDialog.vue?vue&type=template&id=80b6f480"
import script from "./EditTagScoreDialog.vue?vue&type=script&lang=ts"
export * from "./EditTagScoreDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports